import { useEffect, useCallback } from "react";
import Input from "../../../../../components/input/Input";
import MaskInput from "../../../../../components/input/MaskInput";
import MultipleSelect from "../../../../../components/input/MultipleSelect";
import { ColorPicker } from "primereact/colorpicker";
import { Controller } from "react-hook-form";
import { useWebsite } from "../Context/WebSiteContext";
import { InputText } from "primereact/inputtext";

const MenuSite = ({ form, setFormData, optionsnavbar, setValue, config }) => {
  const { formData, updateFormData } = useWebsite();

  const instagramValue =
    config?.navbar?.link_instagram ??
    config?.link_instagram ??
    formData?.navbar?.link_instagram ??
    formData?.link_instagram ??
    "";

  const whatsappValue =
    config?.navbar?.Tel_Site ??
    config?.Tel_Site ??
    formData?.navbar?.Tel_Site ??
    formData?.Tel_Site ??
    "";

  const navLinksValue = Array.isArray(formData?.navbar?.nav_links)
    ? formData.navbar.nav_links
        .map((item) =>
          typeof item === "object" && item !== null ? item.value : item
        )
        .filter(Boolean)
    : [];

  const mergedOptionsNavbar =
    Array.isArray(optionsnavbar) && optionsnavbar.length > 0
      ? optionsnavbar
      : [
          { name: "Inicio", value: "Home" },
          { name: "Sobre", value: "Sobre" },
          { name: "Galeria", value: "Galeria" },
          { name: "Contato", value: "Contato" },
        ];

  useEffect(() => {
    if (!formData.navbar) {
      updateFormData("navbar", null, {});
      return;
    }

    const initialColorNav =
      formData.navbar?.colornav || config?.navbar?.colornav || "#ffffff";
    const initialColorNavText =
      formData.navbar?.colornavtext ||
      config?.navbar?.colornavtext ||
      "#000000";

    if (formData.navbar?.colornav !== initialColorNav) {
      updateFormData("navbar", "colornav", initialColorNav);
      setValue("navbar.colornav", initialColorNav, { shouldDirty: false });
    }

    if (formData.navbar?.colornavtext !== initialColorNavText) {
      updateFormData("navbar", "colornavtext", initialColorNavText);
      setValue("navbar.colornavtext", initialColorNavText, {
        shouldDirty: false,
      });
    }

    setValue("navbar.link_instagram", instagramValue, { shouldDirty: false });
    setValue("navbar.Tel_Site", whatsappValue, { shouldDirty: false });
    setValue("navbar.nav_links", navLinksValue, { shouldDirty: false });
    // eslint-disable-next-line
  }, [
    instagramValue,
    whatsappValue,
    navLinksValue,
    config,
    formData.navbar,
    setValue,
  ]);

  const handleInputChange = useCallback(
    (field, value) => {
      updateFormData("navbar", field, value);
      setValue(`navbar.${field}`, value, { shouldDirty: true });
    },
    [updateFormData, setValue]
  );

  const handleColorChange = useCallback(
    (field, value) => {
      updateFormData("navbar", field, value);
      setValue(`navbar.${field}`, value, { shouldDirty: true });
      console.log(`Cor do ${field} alterada para:`, value);
    },
    [updateFormData, setValue]
  );

  const handleLinksChange = (e) => {
    console.log("Evento recebido em handleLinksChange:", e);
    setValue("navbar.nav_links", e, { shouldDirty: true });
    updateFormData("navbar", "nav_links", e);
    console.log("Links do menu atualizados:", e);
  };

  const preventSubmit = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    setValue("navbar.Tel_Site", whatsappValue, { shouldDirty: false });
  }, [whatsappValue, setValue]);

  return (
    <div className="row g-2 align-items-start" onKeyDown={preventSubmit}>
      <div className="col-md-6 pe-md-2">
        <Input
          type="text"
          control={form.control}
          label="Usuario do instagram"
          name="navbar.link_instagram"
          className="form-control"
          defaultValue={instagramValue}
          onChange={(e) => handleInputChange("link_instagram", e.target.value)}
          onKeyDown={preventSubmit}
        />
      </div>

      <div className="col-md-6 ps-md-2">
        <Input
          name="navbar.Tel_Site"
          control={form.control}
          onChange={(e) => handleInputChange("Tel_Site", e.target.value)}
          label="Adicione o Whatsapp"
          className="w-100"
          defaultValue={whatsappValue}
          onKeyDown={preventSubmit}
        />
      </div>

      <div className="col-12 mt-3">
        <MultipleSelect
          name="navbar.nav_links"
          control={form.control}
          optionLabel="name"
          optionValue="value"
          options={mergedOptionsNavbar}
          value={navLinksValue}
          placeholder="Selecione os links"
          label="Quais links deseja manter no menu de navegação?"
          onChange={handleLinksChange}
          onKeyDown={preventSubmit}
        />
      </div>

      <div className="row g-2 mt-3">
        <div className="col-md-6 pe-md-2">
          <div className="card p-3">
            <h5 className="mb-3">Escolha a cor do fundo do menu</h5>
            <div className="d-flex flex-row align-items-center justify-content-center gap-2">
              <Controller
                name="navbar.colornav"
                control={form.control}
                defaultValue={formData.navbar?.colornav || "#000000"}
                render={({ field }) => (
                  <>
                    <ColorPicker
                      value={field.value?.replace("#", "")}
                      onChange={(e) => {
                        const hex = "#" + e.value;
                        field.onChange(hex);
                        handleColorChange("colornav", hex);
                      }}
                      format="hex"
                    />
                    <InputText
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        handleColorChange("colornav", e.target.value);
                      }}
                      placeholder="#000000"
                      className="w-100 text-center"
                    />
                  </>
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6 ps-md-2">
          <div className="card p-3">
            <h5 className="mb-3">Escolha a cor do texto do menu</h5>
            <div className="d-flex flex-row align-items-center justify-content-center gap-2"> 
              <Controller
                name="navbar.colornavtext"
                control={form.control}
                defaultValue={formData.navbar?.colornavtext || "#000000"}
                render={({ field }) => (
                  <>
                    <ColorPicker
                      value={field.value?.replace("#", "")}
                      onChange={(e) => {
                        const hex = "#" + e.value;
                        field.onChange(hex);
                        handleColorChange("colornavtext", hex);
                      }}
                      format="hex"
                    />
                    <InputText
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        handleColorChange("colornavtext", e.target.value);
                      }}
                      placeholder="#000000"
                      className="w-100 text-center"
                    />
                  </>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuSite;
